import script from "./ConfirmProblemCancelPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmProblemCancelPopup.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmProblemCancelPopup.vue?vue&type=style&index=0&id=35e2c9fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35e2c9fa"]])

export default __exports__